/*
  AYO motion (Theme settings > AYO store > Animation). Loaded by snippets/ayo-motion.liquid.
  1. Cards and boxes below the first screen rise in once as they scroll into view.
     Only things that start below the screen are hidden first, so nothing on screen blinks.
  2. When something is added to the bag, its photo flies to the bag icon and the bag jumps.
  Off for people who ask their phone for less motion. The reveal is off inside the theme editor.
*/
(function () {
  if (window.__ayoMotion) return;
  window.__ayoMotion = true;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const cfg = window.ayoMotion || {};

  /* 1. reveal */
  const REVEAL = '.ayo-card, .ayo-trust__item, .ayo-size__box, .ayo-cat';
  const reveal = () => {
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) return;
    const main = document.getElementById('MainContent') || document.querySelector('main');
    if (!main) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target;
        io.unobserve(el);
        el.classList.add('ayo-m-in');
        el.classList.remove('ayo-m-hide');
        setTimeout(() => el.classList.remove('ayo-m-in'), 2600);
      });
    }, { threshold: 0.12 });
    const vh = window.innerHeight;
    main.querySelectorAll(REVEAL).forEach((el) => {
      const r = el.getBoundingClientRect();
      if (!r.width || r.top < vh) return;
      const sibs = el.parentElement ? Array.from(el.parentElement.children) : [];
      el.style.setProperty('--ayo-m-i', String(Math.max(0, sibs.indexOf(el)) % 6));
      el.classList.add('ayo-m-hide');
      io.observe(el);
    });
  };

  /* 2. fly to bag */
  let last = null;
  const PRODUCT = '.ayo-card, .ayo-sc__item, .ayo-pdp, .ayo-fp, .ayo-og, .ayo-pair, .ayo-cart__up, product-info, .product';
  document.addEventListener('click', (e) => {
    const box = e.target.closest && e.target.closest(PRODUCT);
    const img = box && box.querySelector('img');
    if (img) last = { img, t: Date.now() };
  }, true);

  const visible = (el) => { if (!el) return null; const r = el.getBoundingClientRect(); return r.width && r.height && r.bottom > 0 && r.top < window.innerHeight ? el : null; };
  const bagIcon = () => visible(document.getElementById('cart-icon-bubble')) || visible(document.querySelector('[data-ayo-dock-cart]'));
  const pop = (el) => { if (!el) return; el.classList.remove('ayo-m-pop'); void el.offsetWidth; el.classList.add('ayo-m-pop'); setTimeout(() => el.classList.remove('ayo-m-pop'), 700); };

  let lastFly = 0;
  const onAdded = () => {
    const now = Date.now();
    if (now - lastFly < 600) return;
    lastFly = now;
    setTimeout(() => {
      const bag = bagIcon();
      const src = last && now - last.t < 15000 ? last.img : null;
      const drawerOpen = document.querySelector('cart-drawer.active, cart-drawer[open], cart-notification.active, .ayo-cart-sheet[open]');
      const from = src && visible(src);
      if (cfg.fly === false || !bag || !from || drawerOpen) { pop(bag); return; }
      const f = from.getBoundingClientRect(), t = bag.getBoundingClientRect();
      const size = Math.min(110, Math.max(56, f.width * 0.6));
      const c = document.createElement('img');
      c.src = from.currentSrc || from.src;
      c.alt = '';
      c.className = 'ayo-m-fly';
      Object.assign(c.style, { left: (f.left + f.width / 2 - size / 2) + 'px', top: (f.top + f.height / 2 - size / 2) + 'px', width: size + 'px', height: size + 'px' });
      document.body.appendChild(c);
      const dx = t.left + t.width / 2 - (f.left + f.width / 2), dy = t.top + t.height / 2 - (f.top + f.height / 2);
      const anim = c.animate([
        { transform: 'translate(0, 0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 90}px) scale(.7)`, opacity: 1, offset: 0.5 },
        { transform: `translate(${dx}px, ${dy}px) scale(.12)`, opacity: 0.5 }
      ], { duration: 800, easing: 'cubic-bezier(.4, 0, .2, 1)' });
      const done = () => { c.remove(); pop(bag); };
      anim.onfinish = done;
      setTimeout(() => { if (c.isConnected) done(); }, 1200);
    }, 80);
  };
  document.addEventListener('ayo:cart-changed', onAdded);
  const hook = () => { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => { if (!ev || ev.source !== 'cart-items') onAdded(); }); };

  const start = () => { reveal(); hook(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
